<template>
  <b-modal
    @change="change"
    :visible="value"
    :modal-class="`theme-${$setup.theme}-modals`"
    size="lg"
    scrollable
    hide-footer
    hide-header
    centered
  >
    <div class="quiz-modal-component py-4">
      <button class="btn icon-close" @click="$emit('input', false)"></button>

      <quiz-over
        v-if="finished"
        :score="score"
        :msg="finish_message"
        :reason="reason"
        @retry="retry"
        @close="$emit('input', false)"
        :retryLoading="startLoading"
      />

      <quiz-opened
        v-else-if="score && step == 0"
        :score="score"
        @save="save"
        @on-answer="onAnswer"
        @timeover="finished = true"
        @clear-local-storage="clearLocalStorage"
        :submitLoading="submitLoading"
      />

      <quiz-result
        v-else-if="score && step == 1"
        :score="score"
        @answer-keys="step = 2"
        @close="$emit('input', false)"
        @retry="retry"
        :retryLoading="startLoading"
      />

      <quiz-answer-sheet
        v-else-if="step == 2"
        :score="score"
        @close="$emit('input', false)"
      />
    </div>
  </b-modal>
</template>
<script>
import {
  QuizAnswerSheet,
  QuizOver,
  QuizResult,
  QuizOpened
} from "@/components/lesson/quiz/fragment";

export default {
  components: {
    QuizAnswerSheet,
    QuizOver,
    QuizResult,
    QuizOpened
  },
  props: {
    value: Boolean,
    quiz: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isAnswered() {
      return this.score.answer_keys.length && this.score.quiz_answers.length;
    },
    isApproved() {
      return this.score.score >= this.score.quiz.approval_average;
    }
  },
  data() {
    return {
      step: 0,
      loading: false,
      startLoading: false,
      submitLoading: false,
      finished: false,
      reason: null,
      finish_message: "",
      score: null,
      answers: null,
      result: {
        right: 5,
        missing: 10
      },
      STORAGE_KEYS: {
        TIMEOUT: `${window.location.host}_QUIZ_TIMEOUT_${this.$user.user.email}`,
        ANSWERS: `${window.location.host}_QUIZ_ANSWERS_${this.$user.user.email}`
      }
    };
  },
  mounted() {
    this.startQuizz();
  },
  methods: {
    change(val) {
      this.$emit("input", val);
    },
    clearLocalStorage() {
      localStorage.removeItem(this.STORAGE_KEYS.TIMEOUT);
      localStorage.removeItem(this.STORAGE_KEYS.ANSWERS);
    },
    startQuizz() {
      if (this.startLoading) return;
      this.startLoading = true;
      this.$store
        .dispatch("quiz/startQuiz", this.quiz.code)
        .then(data => {
          this.score = data;
          this.step = 0;
          this.clearLocalStorage();
        })
        .catch(e => {
          const errors = Object.keys(e.response.data);
          if (errors.includes("time_limit_minutes")) {
            this.finish_message = "Tempo esgotado";
            this.reason = "time_limit_minutes";
            this.finished = true;
          }
          if (errors.includes("number_of_attempts")) {
            this.finish_message = "Limite de tentativas atingido";
            this.reason = "number_of_attempts";
            this.finished = true;
          }
        })
        .finally(() => {
          this.startLoading = false;
        });
    },
    onAnswer(answers) {
      this.score.quiz_answers = answers;
    },
    retry() {
      this.finished = false;
      localStorage.removeItem(this.STORAGE_KEYS.TIMEOUT);
      this.startQuizz();
    },
    save(quiz_answers) {
      this.answers = quiz_answers;
      if (this.submitLoading) return;

      this.submitLoading = true;

      this.$store
        .dispatch("quiz/saveAnswer", {
          score_code: this.score.code,
          quiz_code: this.score.quiz.code,
          quiz_answers
        })
        .then(data => {
          this.score = data;
          this.step = 1;
          this.clearLocalStorage();
          this.$emit("update");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.quiz-modal-component {
  .icon-close {
    position: absolute;
    top: 2%;
    right: 0%;
  }

  .page-title {
    .icon-exam {
      font-size: 20px;
    }
  }
}
</style>
